import React, {createContext, useContext} from "react";

// Hooks
import useLocalStorage from "../common/hooks/use-local-storage";

const filtersContext = createContext();

const useFilters = () => {
    return useContext(filtersContext);
};

const useProvideFilters = () => {

    // save filters state on localStorage
    const [deliveryNotesFilters, setDeliveryNotesFilters, removeDeliveryNotesFilters] = useLocalStorage("ac-extranet.deliveryNotesFilters");
    const [invoicesFilters, setInvoicesFilters, removeInvoicesFilters] = useLocalStorage("ac-extranet.invoicesFilters");
    const [technicalSheetsFilters, setTechnicalSheetsFilters, removeTechnicalSheetsFilters] = useLocalStorage("ac-extranet.technicalSheetsFilters");
    const [dateFilters, setDateFilters, removeDateFilters] = useLocalStorage("ac-extranet.dateFilters");
    const [transportationFilters, setTransportationFilters, removeTransportationFilters] = useLocalStorage("ac-extranet.transportationFilters");

    return {
        deliveryNotesFilters,
        setDeliveryNotesFilters,
        removeDeliveryNotesFilters,
        invoicesFilters,
        setInvoicesFilters,
        removeInvoicesFilters,
        technicalSheetsFilters,
        setTechnicalSheetsFilters,
        removeTechnicalSheetsFilters,
        dateFilters,
        setDateFilters,
        removeDateFilters,
        transportationFilters,
        setTransportationFilters,
        removeTransportationFilters
    };
};

const ProvideFilters = ({children}) => {
    const filters = useProvideFilters();
    return (
        <filtersContext.Provider value={filters}>
            {children}
        </filtersContext.Provider>
    );
};

export {
    ProvideFilters,
    useFilters
}